import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom';
import { Table, Input, Button, Space, Tooltip, InputNumber, Form, Typography, Popconfirm } from 'antd';
import Highlighter from 'react-highlight-words';
import { SearchOutlined, LoadingOutlined } from '@ant-design/icons';
import { encode } from 'js-base64';

const EditableCell = ({
    editing,
    dataIndex,
    title,
    inputType,
    record,
    index,
    children,
    ...restProps
}) => {
    const inputNode = inputType === 'number' ? <InputNumber style={{ width: "100%" }} /> : <Input />;
    return (
        <td {...restProps}>
            {editing ? (
                <Form.Item
                    name={dataIndex}
                    style={{
                        margin: 0,
                    }}
                    rules={[
                        {
                            required: true,
                            message: `Please Input ${title}!`,
                        },
                    ]}
                >
                    {inputNode}
                </Form.Item>
            ) : (
                children
            )}
        </td>
    );
};

export default function DetailTable9({ data, loading}) {

    const Bucket = "https://d1e9ilirjteg2w.cloudfront.net/";

    var searchInput;

    const [form] = Form.useForm();
    const [editingKey, setEditingKey] = useState('');

    const isEditing = (record) => record.key === editingKey;

    const [state, setState] = useState({
        searchText: '',
        searchedColumn: '',
    });

    const getColumnSearchProps = dataIndex => ({
        filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
            <div style={{ padding: 8 }}>
                <Input
                    ref={node => {
                        searchInput = node;
                    }}
                    placeholder={`Search ${dataIndex}`}
                    value={selectedKeys[0]}
                    onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
                    onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
                    style={{ marginBottom: 8, display: 'block' }}
                />
                <Space>
                    <Button
                        type="primary"
                        onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
                        icon={<SearchOutlined />}
                        // size="small"
                        style={{ width: 90 }}
                    >
                        Search
                    </Button>
                    <Button onClick={() => handleReset(clearFilters)} style={{ width: 90 }}>
                        Reset
                    </Button>
                </Space>
            </div>
        ),
        filterIcon: filtered => <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} />,
        onFilter: (value, record) =>
            record[dataIndex]
                ? record[dataIndex].toString().toLowerCase().includes(value.toLowerCase())
                : '',
        onFilterDropdownVisibleChange: visible => {
            if (visible) {
                setTimeout(() => searchInput.select(), 100);
            }
        },
        render: text =>
            state.searchedColumn === dataIndex ? (
                <Tooltip placement="topLeft" title={
                    <Highlighter
                        highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
                        searchWords={[state.searchText]}
                        autoEscape
                        textToHighlight={text ? text.toString() : ''}
                    />
                }>
                    <Highlighter
                        highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
                        searchWords={[state.searchText]}
                        autoEscape
                        textToHighlight={text ? text.toString() : ''}
                    />
                </Tooltip>
            ) : (
                <Tooltip placement="topLeft" title={text}>{text}</Tooltip>
            ),
    });

    const handleSearch = (selectedKeys, confirm, dataIndex) => {
        confirm();
        setState({
            searchText: selectedKeys[0],
            searchedColumn: dataIndex,
        });
    };

    const handleReset = clearFilters => {
        clearFilters();
        setState({ searchText: '' });
    };

    const columns = [
        {
            title: 'Approach(ID)',
            dataIndex: 'approach(ID)',
            key: 'approach(ID)',
            width: 150,
            editable: false,
            sorter: (a, b) => a["approach(ID)"].localeCompare(b["approach(ID)"]),
            ellipsis: {
                showTitle: false,
            },
            ...getColumnSearchProps('approach(ID)'),
        },
        {
            title: 'Reaction(ID)',
            dataIndex: 'reaction(ID)',
            key: 'reaction(ID)',
            width: 150,
            editable: false,
            sorter: (a, b) => a["reaction(ID)"].localeCompare(b["reaction(ID)"]),
            ellipsis: {
                showTitle: false,
            },
            ...getColumnSearchProps('reaction(ID)'),
        },
        {
            title: 'eaction(ID)',
            dataIndex: 'equation(ID)',
            key: 'equation(ID)',
            width: 250,
            editable: true,
            sorter: (a, b) => a["equation(ID)"].localeCompare(b["equation(ID)"]),
            ellipsis: {
                showTitle: false,
            },
            ...getColumnSearchProps('equation(ID)'),
        },
        {
            title: 'Equation(Name)',
            dataIndex: 'equation(Name)',
            key: 'equation(Name)',
            width: 200,
            editable: false,
            sorter: (a, b) => a["equation(Name)"].localeCompare(b["equation(Name)"]),
            ellipsis: {
                showTitle: false,
            },
            ...getColumnSearchProps('equation(Name)'),
        },
        {
            title: 'Check mass balance',
            dataIndex: 'check_mass_balance',
            key: 'check_mass_balance',
            width: 150,
            editable: false,
            sorter: (a, b) => a["check_mass_balance"].localeCompare(b["check_mass_balance"]),
            ellipsis: {
                showTitle: false,
            },
            ...getColumnSearchProps('check_mass_balance'),
        },
        {
            title: 'Flux',
            dataIndex: 'flux',
            key: 'flux',
            width: 150,
            editable: false,
            sorter: (a, b) => a["flux"] - b["flux"],
            ellipsis: {
                showTitle: false,
            },
            ...getColumnSearchProps('flux'),
        },
        {
            title: 'l_b',
            dataIndex: 'l_b',
            key: 'l_b',
            width: 100,
            editable: true,
            sorter: (a, b) => a["l_b"] - b["l_b"],
            ellipsis: {
                showTitle: false,
            },
            ...getColumnSearchProps('l_b'),
        },
        {
            title: 'u_b',
            dataIndex: 'u_b',
            key: 'u_b',
            width: 100,
            editable: true,
            sorter: (a, b) => a["u_b"] - b["u_b"],
            ellipsis: {
                showTitle: false,
            },
            ...getColumnSearchProps('u_b'),
        }
    ];

    return (
        <>
        <Form form={form} component={false}>
            {/* <div style={{ overflow:"auto"}}> */}
            <Table
                // bordered
              
                id="antdTable"
                rowKey="reaction(ID)"
                columns={columns}
                dataSource={data}
                loading={loading}
                pagination={ data.length > 10 ? true : false}
                scroll={{x:1400}}
            />
            {/* </div> */}
            </Form>

        </>

    );
    // }
}
